module.exports = __webpack_public_path__ + "img/jenkins.62c38a30.png";